module.exports = __webpack_public_path__ + "static/img/wh.730643c3.png";